// A selecao de unidades e salva no localStorage para sobreviver ao F5.
export const UNIDADES_SELECIONADAS_KEY = 'filter_bi_unidades'

export const salvarUnidadesSelecionadas = (unidades) => {
    try {
        localStorage.setItem(UNIDADES_SELECIONADAS_KEY, JSON.stringify(unidades))
    } catch (e) {
        console.error('Erro ao salvar unidades selecionadas:', e)
    }
}

const lerUnidadesSalvas = () => {
    try {
        const unidades = JSON.parse(localStorage.getItem(UNIDADES_SELECIONADAS_KEY))

        if (!Array.isArray(unidades)) {
            return []
        }

        // Restaura apenas unidades que o perfil logado ainda pode acessar.
        const profile = JSON.parse(localStorage.getItem('_profile'))
        const idsPermitidos = new Set((profile?.unidadeList || []).map(u => u.idUnidade))

        return unidades.filter(u => u && idsPermitidos.has(u.idUnidade))
    } catch (e) {
        return []
    }
}

export const initialRealTimeProgress = () => {
    return {
        counting: false,
        progressValue: 0,
        shouldRefetch: false,
        // Indica se já houve ao menos uma busca nesta sessão (reseta no reload).
        // Usado para destacar o filtro / orientar o usuário a clicar em Buscar.
        searched: false,
        // Dialog 'Selecione o período e as unidades': abre ao acessar e fecha
        // ao buscar (ou quando o usuário dispensa no X).
        filterModalOpen: true
    }
};

export const updateProgress = (currentState, action) => {
    const { progress } = action
    return {
        ...currentState,
        progress: { ...currentState.progress, ...progress }
    }
}

export const initialTodaySlices = () => {
    return { unidade: null, recortes: {} }
}

export const iniciarBusca = (currentState, action) => {
    return {
        ...currentState,
        todaySlices: { unidade: action.unidade, recortes: {} }
    }
}

export const updateTodaySlices = (currentState, action) => {
    const { kpi, records, unidade } = action
    const todaySlices = currentState.todaySlices || initialTodaySlices()

    if (unidade !== todaySlices.unidade) {
        return currentState
    }

    return {
        ...currentState,
        todaySlices: {
            unidade: todaySlices.unidade,
            recortes: { ...todaySlices.recortes, [kpi]: records }
        }
    }
}

export const initialTrademarkFilter = () => {
    return {
        selecteds: []
    }
}

export const updateTrademarkFilter = (currentState, action) => {
    const { trademark } = action

    return {
        ...currentState,
        trademark: { ...currentState.trademark, ...trademark }
    }
}

export const initialDashboardFilter = () => {
    return {
        selectedDate: new Date().getTime(),
        unidadeSelected: lerUnidadesSalvas(),
        params: null
    }
}

export const updateDashboardFilter = (currentState, action) => {
    const { dashboardFilter } = action

    return {
        ...currentState,
        dashboardFilter: { ...currentState.dashboardFilter, ...dashboardFilter }
    }
}